module.exports = __webpack_public_path__ + "img/big4-10.52e4c5d8.jpg";